import { makeStyles } from '@material-ui/core/styles';

export function useAttendanceLocalDetailsStyles() {
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
        },
        backButton: {
            color: '#004B97',
            fontSize: '0.95rem',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        }
    }));

    const classes = useStyles();

    return {
        classes,
    };
}